import { Report } from "./report";
import { User } from "./user";

export class SideNote {
  ID: string;
  NOTE: string;
  CREATED_DATE: Date;
  REPORT: Report;
  PRIORITY: Priority;
  REMINDER: Reminder;
  SHARE: boolean;
  USER: User;

  // Helper
  active: boolean;
  allowed = false;
  toShare: boolean;

  static parse(json: any): SideNote {
    if (json) {
      const f = new SideNote();
      f.ID = json.ID;
      f.NOTE = json.NOTE;
      f.CREATED_DATE = json.CREATED_DATE;
      f.REPORT = json.REPORT;
      f.PRIORITY = json.PRIORITY;
      f.REMINDER = json.REMINDER;
      f.SHARE = json.SHARE;

      if(json.REPORT)
        f.REPORT = Report.parse(json.REPORT);

      if(json.USER)
        f.USER = User.parse(json.USER);

      return f;
    } else return null;
  }

  static parseArray(json: any[]): SideNote[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(SideNote.parse(j));

    return arr;
  }

  constructor(){
    this.NOTE = '';
    this.CREATED_DATE = new Date();
    this.PRIORITY = Priority.NONE;
  }

  static createDefault(report: Report): SideNote {
    const s = new SideNote();
    if(report)
      s.REPORT = report;

    s.NOTE = '';
    s.CREATED_DATE = new Date();

    return s;
  }
}

export enum Priority{
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
  NONE = 'NONE'
}

export enum Reminder{
  MINUTES_20 = 'MINUTES_20',
  HOUR = 'HOUR',
  HOUR_3 = 'HOUR_3',
  TOMORROW = 'TOMORROW',
  NEXT_WEEK = 'NEXT_WEEK',
  CUSTOM = 'CUSTOM',
}
